import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
// Workaround: Using local copy due to cml-webui-commons@1.0.2 package export bug
// Package exports './styles' -> './dist/webui-commons.css' but actual file is 'cml-webui-commons.css'
import './styles/cml-webui-commons.css'
// Tailwind utilities for this app's JSX (commons ships only a frozen subset).
// Must come AFTER commons so explicit utilities win specificity ties.
import './styles/tailwind.css'
// TaxHive enhancement layer — imported LAST so it has final say.
import './styles/taxhive-theme.css'
// Swappable accent palettes (orange/indigo/blue) — imported after the theme
// layer so its `html[data-accent]` blocks override the commons primary ramp.
import './styles/color-themes.css'
import { initTheme, initAccent } from './utils/theme'
import App from './App'

// Apply persisted/system theme + accent before first paint to avoid a flash.
initTheme()
initAccent()

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})

window.addEventListener('taxhive:account-changed', () => {
  void queryClient.cancelQueries()
  queryClient.clear()
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
)
